/* import __COLOCATED_TEMPLATE__ from './base.hbs'; */
var _dec, _dec2, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { RECOVERY_REASONS } from '../dormant-recover/base';
export const TWO_FACTOR_UPGRADE_FLOWS = Object.freeze({
  CODE: 'CODE',
  LOADING: 'LOADING',
  SELECT_METHOD: 'SELECT_METHOD'
});
export const PHONE_DELIVERY_METHODS = Object.freeze({
  SMS: 'SMS',
  VOICE: 'VOICE'
});
let TwoFactorUpgradeBaseComponent = (_dec = service('ember-multipass-logging'), _dec2 = service('ember-multipassfe-client'), _class = class TwoFactorUpgradeBaseComponent extends Component {
  get tPrefix() {
    return this.args.tPrefix || '';
  }
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "marketToasts", _descriptor2, this);
    _initializerDefineProperty(this, "logger", _descriptor3, this);
    _initializerDefineProperty(this, "multipassfeClient", _descriptor4, this);
    _defineProperty(this, "config", void 0);
    _defineProperty(this, "methods", Object.freeze({
      AUTH_APP: 'AUTH_APP',
      EMAIL: 'EMAIL',
      SMS: 'SMS'
    }));
    _defineProperty(this, "phoneDeliveryMethods", PHONE_DELIVERY_METHODS);
    _initializerDefineProperty(this, "error", _descriptor5, this);
    _initializerDefineProperty(this, "selectedDetail", _descriptor6, this);
    _initializerDefineProperty(this, "selectedMethod", _descriptor7, this);
    _initializerDefineProperty(this, "selectedPhoneDeliveryMethod", _descriptor8, this);
    _initializerDefineProperty(this, "smsBlockedOptInMessagingModalOpen", _descriptor9, this);
    _initializerDefineProperty(this, "flow", _descriptor10, this);
    _initializerDefineProperty(this, "loading", _descriptor11, this);
    _defineProperty(this, "flows", TWO_FACTOR_UPGRADE_FLOWS);
    _defineProperty(this, "initialize", async () => {
      if (this.args.requiresPrefetch) {
        try {
          await Promise.all([this.multipassfeClient.listTwoFactor(this.args.verificationSource), this.multipassfeClient.status()]);
        } catch (e) {
          this.logger.sentryError(e);
          this.marketToasts.critical(this.intl.t(this.tPrefix + 'generic_errors.other.unknown'));
          this.args.close?.();
          return;
        }
      }
      this.processTwoFactorDetails();
    });
    this.logger.addComponentBreadcrumb('TwoFactorUpgradeBaseComponent');
  }
  get emailDetails() {
    return this.multipassfeClient.twoFactorDetails.filter(x => x.email);
  }
  get smsDetails() {
    return this.multipassfeClient.twoFactorDetails.filter(x => x.sms);
  }
  get authAppDetails() {
    return this.multipassfeClient.twoFactorDetails.filter(x => x.googleauth);
  }
  get isSmsMethod() {
    return this.selectedDetail && this.selectedDetail.sms;
  }
  get isEmailMethod() {
    return this.selectedDetail && this.selectedDetail.email;
  }
  get hideUseAnotherMethodButton() {
    if (this.multipassfeClient.twoFactorDetails.length > 1) {
      return false;
    }
    if (this.isSmsMethod && this.multipassfeClient.canUseVoice) {
      return false;
    }
    return true;
  }
  get isAccountRecoveryFlow() {
    return Object.prototype.hasOwnProperty.call(RECOVERY_REASONS, this.args.verificationSource);
  }
  processTwoFactorDetails() {
    if (this.args.initialFlow && Object.values(TWO_FACTOR_UPGRADE_FLOWS).includes(this.args.initialFlow)) {
      this.setFlow(this.args.initialFlow);
    } else if (this.authAppDetails.length) {
      this.setSelectedMethod(this.methods.AUTH_APP);
      this.sendVerificationCode();
    } else if (this.smsDetails.length > 1) {
      this.setSelectedMethod(this.methods.SMS);
      this.setFlow(this.flows.SELECT_METHOD);
    } else if (this.smsDetails.length === 1) {
      const flow = this.multipassfeClient.canUseVoice ? this.flows.SELECT_METHOD : this.flows.CODE;
      this.setSelectedMethod(this.methods.SMS);
      // When voice is enabled, the user needs to select a delivery method before the code is sent
      if (!this.multipassfeClient.canUseVoice) {
        this.sendVerificationCode();
      }
      this.setFlow(flow);
    } else if (this.emailDetails.length > 0) {
      this.setSelectedMethod(this.methods.EMAIL);
      this.setFlow(this.flows.SELECT_METHOD);
    } else if (this.args.openTwoFactorEnrollFlow) {
      // No available methods to verify, navigate to enroll two factor
      this.args.openTwoFactorEnrollFlow();
    }
  }
  handleMultipassError(error) {
    switch (error.message) {
      //TODO: Add banner component message when component available
      case 'BLOCKED_SMS_NUMBER':
        this.smsBlockedOptInMessagingModalOpen = true;
        break;
      case 'INVALID_ALIAS':
      case 'INVALID_CREDENTIALS':
        this.error = this.intl.t(this.tPrefix + 'two_factor.errors.invalid_verification_code');
        break;
      case 'TEMPORARY_LOCKOUT':
        this.error = this.intl.t(this.tPrefix + 'two_factor.errors.temporary_lockout');
        break;
      default:
        this.logger.sentryError(error);
        this.error = this.intl.t(this.tPrefix + 'generic_errors.other.unknown');
    }
  }
  handleSmsBlockedOptInMessagingModalClose() {
    this.smsBlockedOptInMessagingModalOpen = false;
  }
  setSelectedPhoneDeliveryMethod(newPhoneDeliveryMethod) {
    this.selectedPhoneDeliveryMethod = newPhoneDeliveryMethod;
  }
  setFlow(newFlow) {
    this.flow = newFlow;
  }
  setSelectedDetail(detail, sendVerificationCode = true) {
    this.selectedDetail = detail;
    if (sendVerificationCode) {
      this.sendVerificationCode();
    }
  }
  sendVerificationCode() {
    if (this.selectedDetail.sms) {
      this.sendSmsTwoFactorCode(this.selectedDetail);
    } else if (this.selectedDetail.email) {
      this.sendEmailTwoFactorCode(this.selectedDetail);
    } else if (this.selectedDetail.googleauth) {
      // do nothing
    }
    this.setFlow(this.flows.CODE);
  }
  setSelectedMethod(newMethod) {
    this.selectedMethod = newMethod;
    if (newMethod === this.methods.AUTH_APP) {
      // Set to the first auth app method since currently only one auth app enrollment is allowed
      this.selectedDetail = this.authAppDetails[0];
    } else if (newMethod === this.methods.SMS) {
      // Set the selected method to the first one if it is the only SMS method - otherwise, let the
      // user choose
      this.selectedDetail = this.smsDetails.length === 1 ? this.smsDetails[0] : null;
    } else if (newMethod === this.methods.EMAIL) {
      // Set to the first email method since currently only the primary email alias is the only available email method
      this.selectedDetail = this.emailDetails[0];
    }
  }
  async sendEmailTwoFactorCode(method, resend = false) {
    try {
      await this.multipassfeClient.sendEmailTwoFactorCode(method.email.email, {
        resend
      });
      this.error = undefined;
    } catch (e) {
      this.handleMultipassError(e);
    }
  }
  async sendSmsTwoFactorCode(method, resend = false) {
    try {
      if (this.selectedPhoneDeliveryMethod === this.phoneDeliveryMethods.VOICE) {
        await this.multipassfeClient.sendVoiceTwoFactorCode(method.sms.phone, {
          resend
        });
      } else {
        await this.multipassfeClient.sendSmsTwoFactorCode(method.sms.phone, {
          resend
        });
      }
      this.error = undefined;
    } catch (e) {
      this.handleMultipassError(e);
    }
  }
  async submitCode(verification_code, set_trusted_device) {
    try {
      const data = {
        two_factor_details: {
          created_at: this.selectedDetail.created_at,
          description: this.selectedDetail.description,
          set_trusted_device
        }
      };
      if (this.args.verificationSource) {
        data.two_factor_verification_source = this.args.verificationSource;
      }
      if (this.isSmsMethod) {
        data.two_factor_details.sms = {
          delivery_method: this.selectedPhoneDeliveryMethod,
          phone: this.selectedDetail.sms.phone,
          verification_code
        };
      } else if (this.isEmailMethod) {
        data.two_factor_details.email = {
          verification_code,
          email: this.selectedDetail.email.email
        };
        data.two_factor_details.set_trusted_device = false; // set_trusted_device not eligible for Email 2FA flow
      } else if (this.selectedDetail.googleauth) {
        data.two_factor_details.googleauth = {
          verification_code
        };
      }
      this.loading = true;
      if (this.args.apiSubmit) {
        await this.args.apiSubmit(data);
      } else {
        await this.multipassfeClient.upgradeSessionTwoFactor(data);
      }
      await this.multipassfeClient.status();
      this.error = undefined;
      if (this.args.finish) {
        this.args.finish();
      }
    } catch (e) {
      this.handleMultipassError(e);
    } finally {
      this.loading = false;
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "marketToasts", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "logger", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "multipassfeClient", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "error", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "selectedDetail", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "selectedMethod", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return this.methods.AUTH_APP;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "selectedPhoneDeliveryMethod", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return this.phoneDeliveryMethods.SMS;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "smsBlockedOptInMessagingModalOpen", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "flow", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return TWO_FACTOR_UPGRADE_FLOWS.LOADING;
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "loading", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "handleSmsBlockedOptInMessagingModalClose", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleSmsBlockedOptInMessagingModalClose"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setSelectedPhoneDeliveryMethod", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setSelectedPhoneDeliveryMethod"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setFlow", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setFlow"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setSelectedDetail", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setSelectedDetail"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "sendVerificationCode", [action], Object.getOwnPropertyDescriptor(_class.prototype, "sendVerificationCode"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setSelectedMethod", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setSelectedMethod"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "sendEmailTwoFactorCode", [action], Object.getOwnPropertyDescriptor(_class.prototype, "sendEmailTwoFactorCode"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "sendSmsTwoFactorCode", [action], Object.getOwnPropertyDescriptor(_class.prototype, "sendSmsTwoFactorCode"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "submitCode", [action], Object.getOwnPropertyDescriptor(_class.prototype, "submitCode"), _class.prototype), _class);
export { TwoFactorUpgradeBaseComponent as default };